import { Resources } from '../Api';

class Video extends Resources {
  constructor(carePlanId, id = null) {
    super();

    this.carePlanId = carePlanId;
    this.id = id;
  }

  get url() {
    return `/care_plans/${this.carePlanId}/ap_creator_videos`;
  }
}

export default Video;
